"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Cursor;
var _reactKonva = require("react-konva");
var _jsxRuntime = require("react/jsx-runtime");
function Cursor(_ref) {
  var config = _ref.config;
  var _ref2 = config || {},
    _ref2$enabled = _ref2.enabled,
    enabled = _ref2$enabled === void 0 ? false : _ref2$enabled,
    text = _ref2.text,
    _ref2$position = _ref2.position,
    position = _ref2$position === void 0 ? {
      x: 0,
      y: 0
    } : _ref2$position;
  if (!(enabled || false)) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Text, {
    x: position.x,
    y: position.y,
    offset: {
      x: -8,
      y: -8
    },
    text: text,
    fontSize: 14,
    fontFamily: "Arial",
    fill: "white",
    fontStyle: "bold",
    verticalAlign: "middle",
    stroke: "black",
    strokeWidth: 2,
    fillAfterStrokeEnabled: true
  });
}